export const BG_COLOR = "#1c1c1c";

export const DEFAULT_BUTTON_BG = "#a2a2a2";

export const BLUE = "#1e56ff";
